// Конфигурация API для development и production
// REACT_APP_API_URL обязательна во всех режимах для безопасности

const API_BASE_URL = (() => {
  if (!process.env.REACT_APP_API_URL) {
    throw new Error(
      'REACT_APP_API_URL environment variable is required!\n' +
      'Add to .env file:\n' +
      '  Development: REACT_APP_API_URL=http://localhost:5001/api\n' +
      '  Production:  REACT_APP_API_URL=https://redactorai.ru'
    );
  }
  return process.env.REACT_APP_API_URL;
})();

const API_CONFIG = {
  // Базовый URL API - всегда из переменной окружения
  getBaseURL: () => {
    return API_BASE_URL;
  },

  // Настройки для потоковых запросов (Server-Sent Events)
  getStreamingHeaders: (token) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'Accept': 'text/event-stream',
    'Cache-Control': 'no-cache'
  }),

  // Стандартные заголовки для API запросов
  getStandardHeaders: (token) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }),

  // Настройки timeout для разных типов запросов
  timeouts: {
    default: 30000,       // 30 секунд для обычных запросов
    fileUpload: 900000,   // 15 минут для загрузки файлов
    streaming: 300000     // 5 минут для потоковых запросов
  },

  // Конфигурация для axios (используется для загрузки файлов с прогрессом)
  getAxiosUploadConfig: (token, onUploadProgress, cancelToken) => ({
    headers: {
      'Authorization': `Bearer ${token}`
      // Content-Type НЕ указываем – браузер добавит boundary
    },
    // Лимиты, соответствующие серверу
    maxContentLength: 500 * 1024 * 1024,
    maxBodyLength:  500 * 1024 * 1024,
    timeout: 0,                 // отключаем таймаут axios, полагаемся на Nginx
    onUploadProgress,           // колбэк для обновления прогресса
    cancelToken
  })
};

export default API_CONFIG; 